var EHDI = EHDI || Object.create(null);

EHDI.game = EHDI.game || Object.create(null);

EHDI.game.TailStateEnum = {
  IDLE: 0,
  RUNNING: 1,
  JUMP: 2,
  FALL: 3,
};

EHDI.game.Tail = function () {
  EHDI.aka.Container.call(this);
};

EHDI.game.Tail.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.game.Tail.prototype.init = function (jumpVelocity, gravity, animation, type) {
  this._hitbox;
  this._type = type;

  this._headJumpStartXPos;
  this._headJumped;
  this._targetXPos;

  this._baseSpeed;
  this._currentSpeed;
  this._newX;
  this._prevY;
  this._newY;

  this._jumpVelY;
  this._currentVelY;
  this._gravity;

  this._currentState;
  this._currentPlatform;

  this._randomDistanceToTheTarget;

  this._animation;

  this._doRunAnimation;

  if (this._hitbox == undefined) {
    this._hitbox = new EHDI.game.Hitbox(30, 30, 60, 0, 0x00ff00);

    this.addChild(this._hitbox);
  }

  if (this._animation == null) {
    this._animation = animation;

    this.addChild(this._animation.getDisplay());
  }

  this.stateManager(EHDI.game.TailStateEnum.IDLE);

  this._headJumped = false;
  this._baseSpeed = 0.2;
  this._currentSpeed = this._baseSpeed;

  this._jumpVelY = jumpVelocity;
  this._gravity = gravity;

  this._randomDistanceToTheTarget = Math.random() * 100 + 30;
};

EHDI.game.Tail.prototype.getType = function () {
  return this._type;
}

EHDI.game.Tail.prototype.reset = function () {
  if (this._animation != null) {
    this.removeChild(this._animation.getDisplay());
    EHDI.GetGlobalPool().animationPool.return(this._animation);

    this._animation = null;
  }
}

EHDI.game.Tail.prototype.start = function (xPos, yPos) {
  this.x = xPos;
  this.y = yPos;
  this.rotation = 0;
  this._newX = xPos;
  this._newY = yPos;
  this._prevY = 0;
  this._doRunAnimation = false;

  this.fall();
};

EHDI.game.Tail.prototype.ladderRotate = function () {
  this.rotation = 12;
}

EHDI.game.Tail.prototype.stateManager = function (newState) {
  if (this._currentState != newState) {
    this._currentState = newState;
  }

};

EHDI.game.Tail.prototype.setTargetXPos = function (targetXPos) {
  this._targetXPos = targetXPos - this._randomDistanceToTheTarget;
};

EHDI.game.Tail.prototype.headJumped = function (jumpStartPos) {
  this._headJumpStartXPos = jumpStartPos;
  this._headJumped = true;
};

EHDI.game.Tail.prototype.update = function (delta, mapXPos) {
  if (this._currentState == EHDI.game.TailStateEnum.RUNNING) {
    this.updateHorMovement(delta);
    this.updateJumpChecker(mapXPos);
  } else if (this._currentState == EHDI.game.TailStateEnum.JUMP ||
  this._currentState == EHDI.game.TailStateEnum.FALL) {
    this.updateVerMovement(delta);
  }

  this._hitbox.update(this._newX, this._newY);
};

EHDI.game.Tail.prototype.updatePos = function () {
  this.x = this._newX;
  this.y = this._newY;
};

EHDI.game.Tail.prototype.collidedWithAPlatform = function (newY) {
  this._prevY = this._newY;
  this._newY = newY;
  this._hitbox.update(this._newX, this._newY);

  if (this._doRunAnimation)
    this._animation.changeAnimation('run');

  this.stateManager(EHDI.game.TailStateEnum.RUNNING);
};

EHDI.game.Tail.prototype.jump = function () {
  this._animation.changeAnimation('jump');
  this._headJumped = false;
  this.stateManager(EHDI.game.TailStateEnum.JUMP);
  this._currentVelY = this._jumpVelY;
};

EHDI.game.Tail.prototype.fall = function (enableAnimation) {
  if (enableAnimation)
    this._animation.changeAnimation('jump');
  this.stateManager(EHDI.game.CharacterStateEnum.FALL);
  this._currentVelY = 0;
};

EHDI.game.Tail.prototype.updateJumpChecker = function (mapXPos) {
  if (this._headJumped && ((this.x + mapXPos) >= this._headJumpStartXPos)) {
    this._newX = this._headJumpStartXPos - mapXPos;
    this.jump();
  }
};

EHDI.game.Tail.prototype.updateVerMovement = function (delta) {
  this._currentVelY += this._gravity;

  if (this._currentState == EHDI.game.TailStateEnum.JUMP &&
  this._currentVelY > 0) {
    this.fall(true);
  }

  this._prevY = this._newY;
  this._newY = this.y + this._currentVelY;
};

EHDI.game.Tail.prototype.updateHorMovement = function (delta) {
  if (this.x < this._targetXPos) {
    this._newX = this.x + this._currentSpeed * delta;
    if (this._newX > this._targetXPos) {
      this._doRunAnimation = true;
      this._animation.changeAnimation('run');
      this._newX = this._targetXPos;
    }
  } else if (this.x > this._targetXPos) {
    this._newX = this.x - this._currentSpeed * delta;
    if (this._newX < this._targetXPos) {
      this._doRunAnimation = true;
      this._animation.changeAnimation('run');
      this._newX = this._targetXPos;
    }
  }
};

EHDI.game.Tail.prototype.getHitbox = function () {
  return this._hitbox;
};

EHDI.game.Tail.prototype.getPrevY = function () {
  return this._prevY;
};

EHDI.game.Tail.prototype.getPlatform = function () {
  return this._currentPlatform;
};

EHDI.game.Tail.prototype.getTailState = function () {
  return this._currentState;
};

EHDI.game.Tail.prototype.setPlatform = function (newPlatform) {
  this._currentPlatform = newPlatform;
};
